module.exports = __webpack_public_path__ + "img/Weapon_128.0a0ae623.png";